
import { useState } from "react";
import { ServicesHeader } from "./services/ServicesHeader";
import { ServicesSection } from "./services/ServicesSection";
import { ProductsSection } from "./services/ProductsSection";
import { ServicesDialogs } from "./services/ServicesDialogs";
import { useServicesData } from "./services/hooks/useServicesData";
import { useProductsData } from "./services/hooks/useProductsData";
import { ProductAnalytics } from "./services/ProductAnalytics";
import { ServiceAnalytics } from "./services/ServiceAnalytics";
import { Tabs, TabsList, TabsContent, TabsTrigger } from "@/components/ui/tabs";

export const ServicesTab = () => {
  const [isServiceFormOpen, setIsServiceFormOpen] = useState(false);
  const [isProductFormOpen, setIsProductFormOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("services");
  
  const { services, isServicesLoading } = useServicesData();
  const { products, isProductsLoading } = useProductsData();

  return (
    <div className="space-y-8">
      <ServicesHeader
        onAddService={() => setIsServiceFormOpen(true)}
        onAddProduct={() => setIsProductFormOpen(true)}
      />

      <Tabs 
        value={activeTab} 
        onValueChange={setActiveTab}
        className="w-full"
      >
        <TabsList className="grid grid-cols-4 w-full max-w-md mb-6">
          <TabsTrigger value="services">Services</TabsTrigger>
          <TabsTrigger value="products">Produits</TabsTrigger>
          <TabsTrigger value="serviceAnalytics">Stats Services</TabsTrigger>
          <TabsTrigger value="productAnalytics">Stats Produits</TabsTrigger>
        </TabsList>
        
        <TabsContent value="services" className="space-y-8">
          <ServicesSection 
            services={services || []}
            isLoading={isServicesLoading}
          />
        </TabsContent>
        
        <TabsContent value="products" className="space-y-8">
          <ProductsSection 
            products={products || []}
            isLoading={isProductsLoading}
          />
        </TabsContent>
        
        <TabsContent value="serviceAnalytics" className="space-y-8">
          <ServiceAnalytics />
        </TabsContent>
        
        <TabsContent value="productAnalytics" className="space-y-8">
          <ProductAnalytics />
        </TabsContent>
      </Tabs>

      <ServicesDialogs
        isServiceFormOpen={isServiceFormOpen}
        setIsServiceFormOpen={setIsServiceFormOpen}
        isProductFormOpen={isProductFormOpen}
        setIsProductFormOpen={setIsProductFormOpen}
      />
    </div>
  );
};
